import styled from "styled-components";
import { theme } from "../../styles/theme";

interface ISwitchProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Container = styled.div<ISwitchProps>`
  width: 58px;
  height: 28px;
  padding: 2px;

  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

  display: flex;
  align-items: center;
  justify-content: ${({ isActive }) => {
    if (isActive) {
      return "flex-end";
    }
    return "flex-start";
  }};

  background: ${({ isActive }) => {
    if (isActive) {
      return theme.colors.green1;
    }
    return theme.colors.erro;
  }};
  border-radius: ${theme.border.mediumRadius};
  transition: justify-content 500ms;
  & > div {
    width: 24px;
    height: 24px;

    border-radius: 50%;
    background: ${theme.colors.white};
    box-shadow: 0px 3px 8px rgba(38, 39, 40, 0.03), 0px 1.5px 3px rgba(38, 39, 40, 0.04), 0px 0.5px 1px rgba(38, 39, 40, 0.1);
  }
`;
